<!-- 财务配置 -->
<template>
  <v-sheet max-width style="min-height: 100%">
    <v-tabs>
      <v-tab value="0">随访奖金审阅配置</v-tab>
    </v-tabs>
    <v-divider />
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <FollowUpBonusReviewSetting />
      </v-tab-item>
    </v-tabs-items>
  </v-sheet>
</template>

<script>
import FollowUpBonusReviewSetting from './components/followUpBonusReviewSetting.vue';
export default {
  name: 'Financial',
  components: {
    FollowUpBonusReviewSetting,
  },
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style lang="scss" scoped></style>
